"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Loader = _interopRequireDefault(require("./Loader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Parent = _styledComponents["default"].div.withConfig({
  displayName: "LoadingBlocker__Parent",
  componentId: "bx980u-0"
})(["position:fixed;width:100%;height:100%;top:0;left:0;z-index:2000;"]);

var Overlay = _styledComponents["default"].div.withConfig({
  displayName: "LoadingBlocker__Overlay",
  componentId: "bx980u-1"
})(["width:100%;height:100%;background-color:white;opacity:0.85;display:flex;align-items:center;justify-content:center;"]);

var LoadingBlocker = function LoadingBlocker(_ref) {
  var children = _ref.children,
      type = _ref.type;
  return _react["default"].createElement(Parent, {
    id: "loading-blocker"
  }, _react["default"].createElement(Overlay, null, _react["default"].createElement("div", null, _react["default"].createElement("div", null, _react["default"].createElement(_Loader["default"], {
    type: type
  })), _react["default"].createElement("div", {
    className: "text-center"
  }, children))));
};

LoadingBlocker.defaultProps = {
  type: 1,
  children: null
};
LoadingBlocker.propTypes = {
  type: _propTypes["default"].number,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node])
};
var _default = LoadingBlocker;
exports["default"] = _default;